// Module
var code = "<template class=\"mooring-components-tab\">\n  <require from=\"./grid-lines-container\"></require>\n  <grid-lines-container if.bind=\"data.productionOrderId > 0\" production-order-id.bind=\"data.productionOrderId\"></grid-lines-container>\n</template>\n";
// Exports
export default code;